/**
 * The RGTC (BC4 and BC5) block formats: one or two channels, each an interpolated 8-byte block.
 * Godot samples them through the swizzles `r001` and `rg01` (`texture_storage.cpp:2042-2071`).
 *
 * Ported from bcdec (`thirdparty/misc/bcdec.h` in Godot), used under the MIT licence:
 *
 *   Copyright (c) 2022 Sergii Kudlai
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy of
 *   this software and associated documentation files (the "Software"), to deal in
 *   the Software without restriction, including without limitation the rights to
 *   use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 *   of the Software, and to permit persons to whom the Software is furnished to do
 *   so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in all
 *   copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 *   SOFTWARE.
 */
import { keepRedGreen } from '../../../processing/importTexelPasses';
import { decodeInterpolatedChannel } from './channels';
function decodeRgtcRed(bytes, offset, texels) {
    decodeInterpolatedChannel(bytes, offset, texels, 0);
    for (let at = 1; at < texels.length; at += 4)
        texels[at] = 0;
    keepRedGreen(texels);
}
function decodeRgtcRedGreen(bytes, offset, texels) {
    decodeInterpolatedChannel(bytes, offset, texels, 0);
    decodeInterpolatedChannel(bytes, offset + 8, texels, 1);
    keepRedGreen(texels);
}
export const RGTC_FORMATS = {
    'RGTC Red8': { bytesPerBlock: 8, decode: decodeRgtcRed },
    'RGTC RedGreen8': { bytesPerBlock: 16, decode: decodeRgtcRedGreen },
};
//# sourceMappingURL=rgtc.js.map